import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PROFILE_UI_TRANSLATIONS_KEY } from "../constants";
var en = /*#__PURE__*/_defineProperty({}, PROFILE_UI_TRANSLATIONS_KEY, {
  PROFILE_ACCOUNT: 'Account',
  PROFILE_COMPANY: 'Company',
  PROFILE_NIGHTSWITCH: 'Night Mode',
  PROFILE_PANEL: 'Panel',
  PROFILE_LOGOUT: 'Logout',
  PROFILE_PROFESSOR: 'Professor',
  PROFILE_MENTOR: 'Mentor',
  PROFILE_ADMIN: 'Admin',
  PROFILE_LEADER: 'Leader',
  PROFILE_SUPERVISOR: 'Supervisor',
  PROFILE_MEMBER: 'Member',
  PROFILE_COURSES: 'My Courses',
  PROFILE_PROFILE: 'My Profile',
  PROFILE_MANAGE_ACCOUNT: 'Manage Account',
  PROFILE_HELP_CENTER: 'Help Center',
  PROFILE_CONFIGURATION: 'Configuration',
  PROFILE_MENTORS: 'Mentors',
  SWITCHER_SUPPLANTED: 'Impersonating:',
  SWITCHER_EXIT: 'Exit impersonation',
  SWITCHER_EXIT_MY_ACCOUNT: 'My account',
  SWITCHER_EXIT_ERROR: 'The action could not be executed. Please try again later.',
  SWITCHER_EXIT_SUCCESS: 'Successfully exited impersonation, please wait a moment.',
  // Company Selector
  COMPANY_LABEL: 'COMPANY',
  COMPANY_PLACEHOLDER: 'Select a company',
  COMPANY_SEARCH_PLACEHOLDER: 'Search',
  COMPANY_NO_RESULTS_TITLE: 'No companies found',
  COMPANY_NO_RESULTS_SUBTITLE: 'Try adjusting your search criteria',
  COMPANY_CORPORATE: 'Corporate',
  COMPANY_SUBSIDIARY: 'Subsidiary Company'
});
export default en;